exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div, table {\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\ntable td {\r\n    height: 100%;\r\n}\r\n\r\nimg {\r\n    width: 800px;\r\n    height: 125px;\r\n}\r\n\r\nspan {\r\n    background-color: #022E57;\r\n    padding: 15px;\r\n    color: whitesmoke;\r\n    cursor: pointer;\r\n    border: 5px solid #265B8D;\r\n    border-radius: 10px;\r\n}\r\n\r\nspan:hover {\r\n    background-color: #265B8D;\r\n}\r\n\r\n\r\n@media (max-width: 300px) {\r\n    img {\r\n        width: 300px;\r\n        height: 46.875px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    img {\r\n        width: 500px;\r\n        height: 78.125px;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 345
// module chunks = 1